import PropTypes from 'prop-types'
import styled from 'styled-components'

const Title = styled.h1`
    color: ${props => props.color ? props.color : '#0e5c93'};
    font-weight: 400;
    font-size: 24px; 
    padding: ${props => props.padding ? props.padding : '20px 0'};
    margin: 0;
    text-align: ${props => props.align ? props.align : 'left'};
`

Title.propTypes = {
    color: PropTypes.string,
    align: PropTypes.string,
    padding: PropTypes.string,
}

export default Title



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Atoms/Title.jsx